import plusIcon from "../../../../images/plus-solid.png";
import checkIcon from "../../../../images/check-solid.png";
import * as CommonUtilities from "../../../../common/utils/CommonUtils";

export default function ProductComboProduct(props) {
    let buttonImageToDisplay;
    let productTextDisplay;
    let modifiersToDisplay, modifierDisplayContainer, specialInstrDisplay = "";
    let hasErrorClass = "";
    if (props.groupValidationData.HasError) {
        hasErrorClass = "is-invalid border-danger";
    } else {
        hasErrorClass = "";
    }

    if (props.groupFormData.ProductID == null || props.groupFormData.ProductID == '') {
        productTextDisplay = `Choose ${props.productComboGroupDetails.productComboGroupName}`
        buttonImageToDisplay = <span className="bg-dark rounded-pill d-flex align-items-center justify-content-center" style={{width: "20px", height: "20px", minWidth: "20px"}}><img src={plusIcon} alt="Add" title="Add" style={{width: "10px"}}></img></span>
    } else {
        productTextDisplay = `${props.groupFormData.ProductName}`
        buttonImageToDisplay = <span className="bg-success rounded-pill d-flex align-items-center justify-content-center" style={{width: "20px", height: "20px", minWidth: "20px"}}><img src={checkIcon} alt="Selected" style={{width: "10px"}}></img></span>
        
        // Display Modifiers
        if (props.groupFormData.Mods.length > 0) {
            modifiersToDisplay = props.groupFormData.Mods.map((item) => {
                // Pricing
                // let priceToDisplay = "";
                // if (item.Field.startsWith("SubRadio")) { // Substitution Category - Calculate price difference from original PLU price
                //     priceToDisplay = item.PriceInc - props.groupFormData.PriceIncForComboSubstitution;
                // } else {
                //     priceToDisplay = item.PriceInc;
                // }
                let priceToDisplay = item.PriceInc;
                
                // Format Display Price
                let modifierPriceInc = CommonUtilities.formatDisplayPrice(priceToDisplay);
                
                return <li key={item.PLU}>{item.ModName}<span className="ms-2 ps-1">{modifierPriceInc}</span></li>
            });
            modifierDisplayContainer = 
                <small className="text-muted">
                    <ul className="mb-0">
                        {modifiersToDisplay}
                    </ul>
                </small>
        } else {
            modifierDisplayContainer = <></>;
        }
        
        // Display Special Instructions
        if (props.groupFormData.SpecialInstructions !== '' && props.groupFormData.SpecialInstructions !== null) {
            specialInstrDisplay = <small className="text-muted mt-2"><span className="fw-medium">Note: </span>{props.groupFormData.SpecialInstructions}</small>
        } else {
            specialInstrDisplay = <></>;
        }
    }

    let elementToReturn;
    if (CommonUtilities.StaticFields.PriceType == 'bp8826') {
        // Bulk Pricing
        elementToReturn = <div className="col-12 py-2 d-grid">
            <button type="button" className={`btn btn-light border d-flex flex-row justify-content-start align-items-center py-3 ${hasErrorClass}`} data-productcombogroupid={props.productComboGroupDetails.productComboGroupID} onClick={props.handleProductComboGroupSelect} disabled={props.addToCartError.ButtonsDisabled}>
                {buttonImageToDisplay}
                &emsp;<div className="d-flex flex-column align-items-start text-start text-break">
                    <span>{productTextDisplay}</span>
                    {modifierDisplayContainer}
                    {specialInstrDisplay}
                </div>
            </button>
            <div className="invalid-feedback">{props.groupValidationData.ErrorMessage}</div>
        </div>
    } else {
        elementToReturn = <div className="col-12 py-2 d-grid">
            <button type="button" className={`btn btn-light border d-flex flex-row justify-content-start align-items-center py-3 ${hasErrorClass}`} data-productcombogroupid={props.productComboGroupDetails.productComboGroupID} onClick={props.handleProductComboGroupSelect} disabled={props.addToCartError.ButtonsDisabled}>
                {buttonImageToDisplay}
                &emsp;<div className="d-flex flex-column align-items-start text-start text-break">
                    <span>{productTextDisplay}</span>
                    {modifierDisplayContainer}
                    {specialInstrDisplay}
                </div>
            </button>
            <div className="invalid-feedback">{props.groupValidationData.ErrorMessage}</div>
        </div>
    }

    return (
        <>
            {elementToReturn}
        </>
    )
}